import React, { Component } from 'react';
import 'whatwg-fetch';
class getTimer extends Component {
  constructor(props){
    super(props);
      this.state = {
        resultado:''
      }
    }
//componentDidMount
 componentWillUnmount () {
   clearInterval(this.timer)
 }

getPedidos =()=>{
  let current_datetime = new Date()
  let mes = ""+(current_datetime.getMonth() + 1)
  let dia = ""+current_datetime.getDate()
  if(mes.length===1) mes = "0" + mes
  if(dia.length===1) dia = "0" + dia
  let formatted_date = current_datetime.getFullYear() + "-" + mes + "-" + dia

  const id_sucursal = this.props.id_sucursal
  const id_tipo_permiso = this.props.id_tipo_permiso
  const token_User = this.props.token_User

  if(Number(id_sucursal)===0&&(Number(id_tipo_permiso)===1||Number(id_tipo_permiso)===2)) return
  const url= this.props.dir_url + "webapp/getPedidosSucursal_U";
  const token =  this.props.token
  const resultado = this.state.resultado
  var obj = { accion:'pedidossucursal', token,id_sucursal,formatted_date,id_tipo_permiso,token_User,resultado};
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(obj),
    headers:{
      'Accept':'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => res.json())
  .then((data) => {
    if(data[0].status==="ok"){
      this.props.get_data_pedidos(data[0].msg,Number(data[0].apertura))
        
    }else{
      this.props.get_data_pedidos([],0)
    }
  })
  .catch(console.log)
}
 tick () {
   this.getPedidos()
   if(window.Android) {
     let resultado = window.Android.showToast("ubicacion")
     this.setState({
       resultado
     })
   }else{
     navigator.geolocation.getCurrentPosition(function(position) {
       this.setState({
          resultado: position.coords.latitude+","+position.coords.longitude
        })
     }.bind(this))
   }
 }
 startTimer () {
   clearInterval(this.timer)
   this.timer = setInterval(this.tick.bind(this), 5000)
 }
 stopTimer () {
   clearInterval(this.timer)
 }
 render () {
   return (
     <React.Fragment></React.Fragment>
   )
 }
 componentDidMount (){
  this.getPedidos();
  this.startTimer();
  this.solicitarPermisoNotificaciones();
   // Reproducir audio silencioso

 }
 solicitarPermisoNotificaciones = () => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }
}
export default getTimer;
